export default __webpack_public_path__ + "static/homeless_prevention-87c1ee1ba8b86a25ed8905076bed5fe7.png";